import { useEmployerScreeningQuestionsStore } from './employer-screening-questions.store';
import EmployerScreeningQuestionsPersistence from './employer-screening-questions.persistence';
import MeService from '@/core/shared/me/me.service';
import { InternalError } from '@/core/shared/errors/internal.error';
import type { EmployerScreeningQuestion } from './employer-screening-question.type';
export default class EmployerScreeningQuestionsService {
  private readonly employerScreeningQuestionsPersistence: EmployerScreeningQuestionsPersistence;
  private readonly meService = new MeService();

  constructor() {
    const employerId = this.meService.employer?.id;
    if (!employerId) {
      throw new InternalError('Employer ID is required');
    }
    this.employerScreeningQuestionsPersistence = new EmployerScreeningQuestionsPersistence(
      employerId,
    );
  }

  private readonly employerScreeningQuestionsStore = useEmployerScreeningQuestionsStore();

  public get frequentlyUsedQuestions(): EmployerScreeningQuestion[] {
    return this.employerScreeningQuestionsStore.frequentlyUsedQuestions;
  }

  public set frequentlyUsedQuestions(value: EmployerScreeningQuestion[]) {
    this.employerScreeningQuestionsStore.frequentlyUsedQuestions = value;
  }

  public async fetchFrequentlyUsedQuestions(): Promise<void> {
    const questions =
      await this.employerScreeningQuestionsPersistence.fetchFrequentlyUsedQuestions();
    this.frequentlyUsedQuestions = questions;
  }
}
